(function () {
  var syncing = false;
  /* interval strings must match the Seal plans' real cadence: ML-4-LAV-1/2/3 all
     deliver every 4 weeks (interval WEEK, intervalCount 4), confirmed 2026-07-26. */
  var PRICES = {
    1: { sale: 22.99, discount: 23, interval: 'every 4 weeks', underline: false },
    2: { sale: 19.99, discount: 33, interval: 'every 4 weeks', underline: false },
    3: { sale: 18.99, discount: 37, interval: 'every 4 weeks', underline: false }
  };
  var ONCE_PRICES = {
    1: { sale: 24.99 },
    2: { sale: 22.99 },
    3: { sale: 21.99 }
  };

  function money(value) {
    return '$' + Number(value).toFixed(2);
  }

  function getSelectedJarCount(root) {
    var checked = root.querySelector('[data-scp-jar]:checked');
    return checked ? Number(checked.value) : null;
  }

  function getPurchaseMode(root) {
    var checked = root.querySelector('[data-scp-mode]:checked');
    return checked ? checked.value : 'subscribe';
  }

  function updateJarCards(root, jarCount) {
    Array.prototype.slice.call(root.querySelectorAll('[data-scp-jar-card]')).forEach(function (card) {
      var input = card.querySelector('[data-scp-jar]');
      var active = input && Number(input.value) === jarCount;
      card.classList.toggle('is-selected', active);
      if (input) input.checked = active;
    });
  }

  function getVariantIdForJar(root, jarCount) {
    var checked = root.querySelector('[data-scp-jar]:checked');
    if (checked && checked.getAttribute('data-scp-variant-id')) {
      return checked.getAttribute('data-scp-variant-id');
    }
    return root.getAttribute('data-scp-variant-' + jarCount) || '';
  }

  function syncFormVariant(root, jarCount) {
    if (!jarCount) return;

    var form = root.querySelector('.scp-form');
    if (!form) return;

    var variantId = getVariantIdForJar(root, jarCount);
    var variantInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[data-scp-quantity], input[name="quantity"]');

    if (variantInput && variantId) variantInput.value = variantId;
    if (qtyInput) qtyInput.value = '1';
  }

  function updatePurchaseCards(root, mode) {
    var subscribeCard = root.querySelector('[data-scp-subscribe-card]');
    var onceCard = root.querySelector('[data-scp-once-card]');
    if (subscribeCard) subscribeCard.classList.toggle('is-selected', mode === 'subscribe');
    if (onceCard) onceCard.classList.toggle('is-selected', mode === 'once');
  }

  function syncPrices(root, jarCount, mode) {
    if (!jarCount) return;

    var data = PRICES[jarCount];
    var onceData = ONCE_PRICES[jarCount];
    if (!data || !onceData) return;

    root.dataset.mode = mode;

    var discountBadge = root.querySelector('[data-scp-discount]');
    var bulletDiscount = root.querySelector('[data-scp-bullet-discount]');
    var subPrice = root.querySelector('[data-scp-sub-price]');
    var oncePrice = root.querySelector('[data-scp-once-price]');
    var shipBullet = root.querySelector('[data-scp-ship-bullet]');
    var cartDiscounts = root.querySelectorAll('[data-scp-cart-discount]');

    if (discountBadge) discountBadge.textContent = 'Save ' + data.discount + '%';
    if (bulletDiscount) bulletDiscount.textContent = data.discount + '%';
    if (subPrice) subPrice.textContent = money(data.sale) + ' each';
    if (oncePrice) oncePrice.textContent = money(onceData.sale) + ' each';
    if (shipBullet) {
      shipBullet.innerHTML = 'Ships <span' + (data.underline ? '' : ' class="is-plain"') + '>' + data.interval + '</span>';
    }

    Array.prototype.slice.call(cartDiscounts).forEach(function (cartDiscount) {
      cartDiscount.textContent = data.discount + '% Off';
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-scp-jar-card]')).forEach(function (card) {
      var input = card.querySelector('[data-scp-jar]');
      var salePrice = card.querySelector('[data-scp-jar-sale]');
      if (!input || !salePrice) return;

      var jars = Number(input.value);
      var price = mode === 'once' ? ONCE_PRICES[jars].sale : PRICES[jars].sale;
      salePrice.textContent = money(price) + '/each';
    });
  }

  function selectBundlerOption(form, jarCount) {
    if (!form || !jarCount) return false;

    var bundleRadio = form.querySelector('input[name="bundle_quantity"][value="' + jarCount + '"]');
    if (!bundleRadio) return false;
    if (bundleRadio.checked) return true;

    syncing = true;

    var label = bundleRadio.id ? form.querySelector('label[for="' + bundleRadio.id + '"]') : null;
    if (label) {
      label.click();
    } else {
      bundleRadio.checked = true;
      bundleRadio.dispatchEvent(new Event('input', { bubbles: true }));
      bundleRadio.dispatchEvent(new Event('change', { bubbles: true }));
      bundleRadio.click();
    }

    var container = bundleRadio.closest('.bndlr-radio-container');
    if (container && !bundleRadio.checked) {
      container.click();
    }

    syncing = false;
    return bundleRadio.checked;
  }

  function setBundlerSubscription(form, subscribe) {
    var checkbox = form.querySelector('.bndlr-subscription-checkbox');
    if (!checkbox) return false;
    if (checkbox.checked === subscribe) return true;

    syncing = true;

    var label = checkbox.closest('label');
    if (label) {
      label.click();
    } else {
      checkbox.checked = subscribe;
      checkbox.dispatchEvent(new Event('input', { bubbles: true }));
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncing = false;
    return checkbox.checked === subscribe;
  }

  function getSealOptions(root) {
    var container = root.querySelector('.sls-purchase-options-container');
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('input.sls-option'));
  }

  function getSealOptionIndex(jarCount, mode) {
    if (mode === 'once') return 0;
    return jarCount || 1;
  }

  function numericPlanId(value) {
    if (value === null || value === undefined) return '';
    return String(value).split('/').pop() || '';
  }

  function getExpectedPlanId(root) {
    var checked = root.querySelector('[data-scp-jar]:checked');
    if (!checked) return null;
    var raw = checked.getAttribute('data-selling-plan-id');
    if (raw === null) return null; // attribute absent -> legacy ordinal markup
    return numericPlanId(raw);
  }

  function isSealRadioReady(radio) {
    if (!radio) return false;
    var container = radio.closest('.sls-option-container');
    return Boolean(container && !container.classList.contains('sls-disabled-option-container'));
  }

  function findSealOptionByPlanId(root, planId) {
    var options = getSealOptions(root);
    for (var i = 0; i < options.length; i++) {
      var container = options[i].closest('.sls-option-container');
      var select = container ? container.querySelector('select[name="subs_interval"]') : null;
      if (select && numericPlanId(select.value) === planId) return options[i];
    }
    return null;
  }

  function findSealOneTimeOption(root) {
    var options = getSealOptions(root);
    for (var i = 0; i < options.length; i++) {
      if (options[i].getAttribute('data-type') === 'one_time' || options[i].value === 'one_time') {
        return options[i];
      }
    }
    return options[0] || null;
  }

  function selectSealOptionRadio(root, radio) {
    if (!radio) return false;

    if (radio.checked) {
      syncSellingPlanFromSeal(root, radio);
      return true;
    }

    syncing = true;

    var clickable = radio.closest('[role="radio"]') || radio.parentElement || radio;
    clickable.click();

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncSellingPlanFromSeal(root, radio);
    syncing = false;
    return radio.checked;
  }

  function syncSellingPlanFromSeal(root, radio) {
    var planInput = root.querySelector('input[name="selling_plan"]');
    if (!planInput || !radio) return;

    if (radio.getAttribute('data-type') === 'one_time' || radio.value === 'one_time') {
      planInput.value = '';
      return;
    }

    var container = radio.closest('.sls-option-container');
    var select = container ? container.querySelector('select[name="subs_interval"]') : null;
    if (select && select.value) {
      planInput.value = select.value;
    }
  }

  function selectSealOptionByIndex(root, index) {
    var options = getSealOptions(root);
    if (!options.length) return false;

    var radio = options[index];
    if (!radio) return false;

    if (radio.checked) {
      syncSellingPlanFromSeal(root, radio);
      return true;
    }

    syncing = true;

    var clickable = radio.closest('[role="radio"]') || radio.parentElement || radio;
    clickable.click();

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncSellingPlanFromSeal(root, radio);
    syncing = false;
    return radio.checked;
  }

  function syncAll(root) {
    var form = root.querySelector('.scp-form');
    if (!form) return false;

    var jarCount = getSelectedJarCount(root);
    var mode = getPurchaseMode(root);
    var subscribe = mode === 'subscribe';
    var ready = true;

    if (jarCount && form.querySelector('input[name="bundle_quantity"]')) {
      ready = selectBundlerOption(form, jarCount) && ready;
    }

    if (form.querySelector('.bndlr-subscription-checkbox')) {
      ready = setBundlerSubscription(form, subscribe) && ready;
    }

    var sealOptions = getSealOptions(root);
    if (sealOptions.length) {
      if (mode === 'once') {
        // Never let a stale plan ride along on a one-time purchase.
        var planInput = root.querySelector('input[name="selling_plan"]');
        if (planInput) planInput.value = '';
        var oneTime = findSealOneTimeOption(root);
        if (!oneTime) return true; // widget odd: one-time stays purchasable
        if (!isSealRadioReady(oneTime)) return false;
        return selectSealOptionRadio(root, oneTime);
      }

      var expected = getExpectedPlanId(root);
      if (expected !== null) {
        // Plan-identity path: match ONLY the variant's own plan; option ORDER is irrelevant.
        // Never fall through to ordinal with a known id (the 2026-07-01 outage class).
        if (!expected) return false;
        var match = findSealOptionByPlanId(root, expected);
        if (!match || !isSealRadioReady(match)) return false;
        return selectSealOptionRadio(root, match);
      }

      // Legacy ordinal fallback: only for markup without data-selling-plan-id.
      var index = getSealOptionIndex(jarCount, mode);
      return selectSealOptionByIndex(root, index);
    }

    return false;
  }

  function waitForWidgetAndSync(root, attempts) {
    if (syncAll(root)) return;

    if (attempts > 0) {
      window.setTimeout(function () {
        waitForWidgetAndSync(root, attempts - 1);
      }, 250);
    }
  }

  function initGallery(root) {
    var slidesWrap = root.querySelector('[data-scp-slides]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-scp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-scp-thumb]'));
    var current = root.querySelector('[data-scp-current]');
    var progress = root.querySelector('[data-scp-progress]');
    var prev = root.querySelector('[data-scp-gallery-prev]');
    var next = root.querySelector('[data-scp-gallery-next]');
    var active = 0;

    function setActive(index, scroll) {
      active = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === active);
      });
      thumbs.forEach(function (thumb, idx) {
        thumb.classList.toggle('is-active', idx === active);
      });
      if (current) current.textContent = String(active + 1);
      if (progress) progress.style.width = ((active + 1) / Math.max(1, slides.length) * 100) + '%';
      if (scroll && slides[active]) slides[active].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        setActive(index, true);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        setActive((active - 1 + slides.length) % slides.length, false);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        setActive((active + 1) % slides.length, false);
      });
    }

    if (slidesWrap) {
      var ticking = false;
      var isDragging = false;
      var dragStartX = 0;
      var dragStartScrollLeft = 0;

      slidesWrap.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        isDragging = true;
        dragStartX = event.clientX;
        dragStartScrollLeft = slidesWrap.scrollLeft;
        slidesWrap.classList.add('is-dragging');
        if (slidesWrap.setPointerCapture) slidesWrap.setPointerCapture(event.pointerId);
      });

      slidesWrap.addEventListener('pointermove', function (event) {
        if (!isDragging) return;
        event.preventDefault();
        slidesWrap.scrollLeft = dragStartScrollLeft - (event.clientX - dragStartX);
      });

      function endDrag(event) {
        if (!isDragging) return;
        isDragging = false;
        slidesWrap.classList.remove('is-dragging');
        if (slidesWrap.releasePointerCapture) {
          try {
            slidesWrap.releasePointerCapture(event.pointerId);
          } catch (error) {}
        }
      }

      slidesWrap.addEventListener('pointerup', endDrag);
      slidesWrap.addEventListener('pointercancel', endDrag);
      slidesWrap.addEventListener('pointerleave', endDrag);

      slidesWrap.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var item = slides[0];
          if (!item) return;
          var gap = 8;
          var index = Math.round(slidesWrap.scrollLeft / (item.getBoundingClientRect().width + gap));
          setActive(index, false);
          ticking = false;
        });
      }, { passive: true });
    }

    setActive(0, false);
  }

  function initSubscribeModal(root) {
    var trigger = root.querySelector('[data-scp-sub-info]');
    var modal = root.querySelector('[data-scp-sub-modal]');
    if (!trigger || !modal) return;
    var closeButtons = Array.prototype.slice.call(modal.querySelectorAll('[data-scp-modal-close]'));
    var lastFocus = null;

    function openModal(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('scp-modal-open');
      var close = modal.querySelector('[data-scp-modal-close]');
      if (close) close.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('scp-modal-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    trigger.addEventListener('click', openModal);
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') openModal(event);
    });
    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function initReviewScroll(root) {
    var trigger = root.querySelector('[data-scp-review-scroll]');
    if (!trigger) return;

    function findReviewsTarget() {
      return document.querySelector('.jdgm-review-widget') ||
        document.querySelector('.jdgm-widget:not(.jdgm-preview-badge)') ||
        document.querySelector('[id^="shopify-section-template--"][id*="__177931204779f08099"]');
    }

    function scrollToReviews() {
      var target = findReviewsTarget();
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    trigger.addEventListener('click', scrollToReviews);
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        scrollToReviews();
      }
    });
  }

  function initRoot(root) {
    initGallery(root);
    initReviewScroll(root);
    initSubscribeModal(root);

    var form = root.querySelector('.scp-form');
    if (!form) return;

    root.addEventListener('change', function (event) {
      if (syncing) return;

      if (event.target.matches('[data-scp-jar]')) {
        var jarCount = Number(event.target.value);
        updateJarCards(root, jarCount);
        syncFormVariant(root, jarCount);
        syncPrices(root, jarCount, getPurchaseMode(root));
        waitForWidgetAndSync(root, 8);
      }

      if (event.target.matches('[data-scp-mode]')) {
        var mode = event.target.value;
        updatePurchaseCards(root, mode);
        syncPrices(root, getSelectedJarCount(root), mode);
        waitForWidgetAndSync(root, 8);
      }
    });

    var jarCount = getSelectedJarCount(root);
    var mode = getPurchaseMode(root);
    if (jarCount) {
      updateJarCards(root, jarCount);
      syncFormVariant(root, jarCount);
    }
    updatePurchaseCards(root, mode);
    waitForWidgetAndSync(root, 12);

    /* Submit guard, CAPTURE phase on document: the form sits inside Dawn's <product-form>
       custom element, whose own submit listener preventDefaults and performs an AJAX add —
       so a listener on the form itself runs too late to stop it. Capture at the document
       level runs before any target-phase handler; stopPropagation() keeps the event from
       ever reaching Dawn's handler when the plan is missing or mismatched. */
    document.addEventListener('submit', function (event) {
      if (event.target !== form) return;

      var selectedJar = getSelectedJarCount(root);
      if (selectedJar) syncFormVariant(root, selectedJar);
      syncAll(root);

      var mode = getPurchaseMode(root);
      var planInput = form.querySelector('input[name="selling_plan"]');

      if (mode === 'once') {
        // One-time must never submit a plan — and stays purchasable even if Seal is absent.
        if (planInput) planInput.value = '';
        return;
      }

      var expected = getExpectedPlanId(root);
      if (expected === null) return; // legacy markup: keep old behavior

      var actual = planInput ? numericPlanId(planInput.value) : '';
      if (!expected || actual !== expected) {
        event.preventDefault();
        event.stopPropagation();
        if (window.console && console.error) {
          console.error('PDP subscribe guard: expected plan ' + expected + ', got "' + actual + '"');
        }
        window.alert('Sorry, the subscription option is temporarily unavailable. Please try again in a moment or choose one-time purchase.');
      }
    }, true);

    var observer = new MutationObserver(function () {
      if (
        root.querySelector('.sls-purchase-options-container') ||
        form.querySelector('input[name="bundle_quantity"]') ||
        form.querySelector('.bndlr-subscription-checkbox')
      ) {
        waitForWidgetAndSync(root, 4);
      }
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('.scp-root')).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
